import { useAtom } from "jotai";
import { dnisNoProcesadosAtom, loadingAtom, puntosAtom } from "../store/store";
import { PuntosService } from "services/comunicacion-cultura";
import { saveAs } from "file-saver";

const usePuntosPage = () => {

    const [puntos, setPuntos] = useAtom(puntosAtom);
    const [loading, setLoading] = useAtom(loadingAtom);
    const [dnisNoProcesados, setDnisNoProcesados] = useAtom(dnisNoProcesadosAtom);

    const fetchPuntos = async (params) => {
        const puntos = await PuntosService.listar(params);
        setPuntos(puntos);
    }

    const exportar = async () => {
        try {
            setLoading(true);
            const response = await PuntosService.exportar();
            const filename = response?.headers?.filename;
            saveAs(response.data, filename);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("No se pudo generar el excel");
        }
    }

    return {
        puntos,
        loading,
        dnisNoProcesados,
        setDnisNoProcesados,
        exportar,
        fetchPuntos
    };
};

export default usePuntosPage;